import type { BlockType, ColorId } from './block';

// types
//-----------------------------------------------------------------------------
export type SymbolId =
  | `bomb_${ColorId}`
  | `rocket_${ColorId}`
  | `cube_${ColorId}`
  | 'club'
  | 'diamond'
  | 'heart'
  | 'joker'
  | 'spade';

type SymbolProps = {
  asset: string;
  type: BlockType;
};

// maps
//-----------------------------------------------------------------------------
export const symbolMap: Record<SymbolId, SymbolProps> = {
  bomb_all: {
    asset: 'symbol.bomb.png',
    type: 'bomb',
  },
  bomb_red: {
    asset: 'symbol.bomb.png',
    type: 'bomb',
  },
  bomb_green: {
    asset: 'symbol.bomb.png',
    type: 'bomb',
  },
  bomb_blue: {
    asset: 'symbol.bomb.png',
    type: 'bomb',
  },
  bomb_yellow: {
    asset: 'symbol.bomb.png',
    type: 'bomb',
  },
  bomb_purple: {
    asset: 'symbol.bomb.png',
    type: 'bomb',
  },

  cube_all: {
    asset: 'symbol.cube.png',
    type: 'cube',
  },
  cube_red: {
    asset: 'symbol.cube.png',
    type: 'cube',
  },
  cube_green: {
    asset: 'symbol.cube.png',
    type: 'cube',
  },
  cube_blue: {
    asset: 'symbol.cube.png',
    type: 'cube',
  },
  cube_yellow: {
    asset: 'symbol.cube.png',
    type: 'cube',
  },
  cube_purple: {
    asset: 'symbol.cube.png',
    type: 'cube',
  },

  rocket_all: {
    asset: 'symbol.rocket.png',
    type: 'rocket',
  },
  rocket_red: {
    asset: 'symbol.rocket.png',
    type: 'rocket',
  },
  rocket_green: {
    asset: 'symbol.rocket.png',
    type: 'rocket',
  },
  rocket_blue: {
    asset: 'symbol.rocket.png',
    type: 'rocket',
  },
  rocket_yellow: {
    asset: 'symbol.rocket.png',
    type: 'rocket',
  },
  rocket_purple: {
    asset: 'symbol.rocket.png',
    type: 'rocket',
  },

  club: {
    asset: 'symbol.club.png',
    type: 'basic',
  },
  diamond: {
    asset: 'symbol.diamond.png',
    type: 'basic',
  },
  heart: {
    asset: 'symbol.heart.png',
    type: 'basic',
  },
  joker: {
    asset: 'symbol.joker.png',
    type: 'basic',
  },
  spade: {
    asset: 'symbol.spade.png',
    type: 'basic',
  },
};

export const newSymbolMap: Record<SymbolId, SymbolProps> = {
  bomb_all: {
    asset: 'symbol.bomb.png',
    type: 'bomb',
  },
  bomb_red: {
    asset: 'symbol.bomb.png',
    type: 'bomb',
  },
  bomb_green: {
    asset: 'symbol.bomb.png',
    type: 'bomb',
  },
  bomb_blue: {
    asset: 'symbol.bomb.png',
    type: 'bomb',
  },
  bomb_yellow: {
    asset: 'symbol.bomb.png',
    type: 'bomb',
  },
  bomb_purple: {
    asset: 'symbol.bomb.png',
    type: 'bomb',
  },

  cube_all: {
    asset: 'symbol.cube.png',
    type: 'cube',
  },
  cube_red: {
    asset: 'symbol.cube.png',
    type: 'cube',
  },
  cube_green: {
    asset: 'symbol.cube.png',
    type: 'cube',
  },
  cube_blue: {
    asset: 'symbol.cube.png',
    type: 'cube',
  },
  cube_yellow: {
    asset: 'symbol.cube.png',
    type: 'cube',
  },
  cube_purple: {
    asset: 'symbol.cube.png',
    type: 'cube',
  },

  rocket_all: {
    asset: 'symbol.rocket.png',
    type: 'rocket',
  },
  rocket_red: {
    asset: 'symbol.rocket.png',
    type: 'rocket',
  },
  rocket_green: {
    asset: 'symbol.rocket.png',
    type: 'rocket',
  },
  rocket_blue: {
    asset: 'symbol.rocket.png',
    type: 'rocket',
  },
  rocket_yellow: {
    asset: 'symbol.rocket.png',
    type: 'rocket',
  },
  rocket_purple: {
    asset: 'symbol.rocket.png',
    type: 'rocket',
  },

  club: {
    asset: 'symbol.club.png',
    type: 'basic',
  },
  diamond: {
    asset: 'symbol.diamond.png',
    type: 'basic',
  },
  heart: {
    asset: 'symbol.heart.png',
    type: 'basic',
  },
  joker: {
    asset: 'symbol.joker.png',
    type: 'basic',
  },
  spade: {
    asset: 'symbol.spade.png',
    type: 'basic',
  },
};
